import { NgModule, ModuleWithProviders } from '@angular/core';
import {
  MsalService,
  MsalInterceptor,
  MSAL_INSTANCE,
  MSAL_GUARD_CONFIG,
  MSAL_INTERCEPTOR_CONFIG,
  MsalInterceptorConfiguration,
  MsalGuardConfiguration,
  MsalGuard,
  MsalBroadcastService,
  MsalModule,
} from '@azure/msal-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';
import { environment } from '../../environments/environment';

const config = {
  auth: {
    clientId: environment.clientIdMsal,
    redirectUri: environment.redirectUriMsal,
    authority: environment.authorityMsal,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: false
  },
  scopes : ['User.Read']
}

const loggerCallback = (logLevel?: LogLevel, message?: string) => {
  switch (logLevel) {
    case LogLevel.Error:
    case LogLevel.Warning:
      setTimeout(() => {
        window.dispatchEvent(new Event('resize')); // Ugly fix, white screen error
      }, 200);
      break;
  }
  return true;
};

const msalInstanceFactory = (): IPublicClientApplication => {

  return new PublicClientApplication({
    auth: config.auth,
    cache: config.cache,
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: true,
      },
    },
  });
};

const msalGuardConfigFactory = (): MsalGuardConfiguration => {

  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: config.scopes,
    },
    loginFailedRoute: '/login-failed',
  };
};

const msalInterceptorConfigFactory = (): MsalInterceptorConfiguration => {

  const protectedResourceMap = new Map<string, string[]>();

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
};

@NgModule({
  providers: [],
  imports: [MsalModule],
})
export class MsalApplicationModule {
  static forRoot(): ModuleWithProviders<MsalApplicationModule> {
    return {
      ngModule: MsalApplicationModule,
      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: MsalInterceptor,
          multi: true,
        },
        {
          provide: MSAL_INSTANCE,
          useFactory: msalInstanceFactory
        },
        {
          provide: MSAL_GUARD_CONFIG,
          useFactory: msalGuardConfigFactory
        },
        {
          provide: MSAL_INTERCEPTOR_CONFIG,
          useFactory: msalInterceptorConfigFactory
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
      ],
    };
  }
}
